"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handler = handler;
var _apiEventClient = require("@abacus/api-event-client");
var _commonUtils = require("@abacus/common-utils");
var _adjustmentFileHandler = require("./file/adjustmentFileHandler");
var _singletons = require("./singletons");
var _local = require("./utils/storage/local");
async function handler(event) {
  try {
    // Check event name
    if (event.event_name != _apiEventClient.AbacusEventName.AdjustmentFileUpload) {
      throw new Error(`Invalid event name '${event.event_name}'`);
    }

    // Check event target type
    if (event.target_type != _apiEventClient.AbacusEventTargetType.StatementPeriodAdjustmentFile) {
      throw new Error(`Invalid event target type '${event.target_type}'`);
    }

    // Sanitize event target ID
    const adjustmentFileId = (0, _commonUtils.toNumber)(event.target_id);
    if (adjustmentFileId == null || !(0, _commonUtils.isInt)(adjustmentFileId)) {
      throw new Error(`Invalid event target ID: ${event.target_id}`);
    }

    // Initialize sentry
    await (0, _singletons.initSentry)();

    // Process the adjustment file
    const processor = new _adjustmentFileHandler.AdjustmentFileHandler({
      localStorageClient: new _local.LocalStorageClient(),
      logger: await (0, _singletons.getLogger)(),
      royaltiesClient: (0, _singletons.getAbacusRoyaltiesClient)(),
      s3Client: (0, _singletons.getS3Client)(),
      snowflakeClient: await (0, _singletons.getSnowflakeClient)(),
      stateClient: (0, _singletons.getAbacusStateClient)(),
      statementPeriodAdjustmentFileId: adjustmentFileId
    });
    const startTime = performance.now();
    await processor.process();
    const endTime = performance.now();

    // Log the processing time
    const diff = endTime - startTime;
    console.info(`Finished processing in ${diff}`);

    // Return success response
    return {
      status: "OK"
    };
  } catch (error) {
    console.error(`${error.message}`);
    throw error;
  }
}